// ═══════════════════════════════════════════════════════════════════════════
//  HASSMARKET PRO — Données marché Hass Europe
// ═══════════════════════════════════════════════════════════════════════════
//
//  🔄 CHECKLIST DE MISE À JOUR HEBDOMADAIRE
//  (à faire chaque semaine après réception du PDF ProHass + Excel manifest)
//
//  1. LAST_UPDATE   ← changer la date (ci-dessous)
//  2. MANIFEST_DATE ← date du dernier Excel manifest (en bas du fichier)
//  3. LATEST_WEEK   ← numéro de la nouvelle semaine
//  4. REAL_WEEKS    ← ajouter la nouvelle semaine au tableau
//  5. CIRAD_REF     ← ajouter la nouvelle valeur S{n} (souvent 1 sem en retard)
//  6. WEEKLY_SUPPLY_EU ← ajouter le total EU de la nouvelle semaine
//  7. REAL_PRICES   ← ajouter un bloc S{n} (4 origines × calibres)
//  8. PERU_EU_CONTAINERS_BY_WEEK ← ajouter la nouvelle semaine
//  9. TOP_IMPORTERS ← pour CHAQUE importateur, ajouter une clé dans weeks:{}
//                     + mettre à jour cumul
// 10. FORECAST_WEEKS, FORECAST_PRICES, FORECAST_SUPPLY, FORECAST_TREND,
//     FORECAST_STRATEGY ← décaler la fenêtre vers l'avant (+1 semaine)
// 11. FORECAST_FACTORS, PERU_2026_INSIGHTS ← rafraîchir le narratif si besoin
//
//  TOUS LES LABELS, KPI, % de part de marché, sous-titres et le prompt IA
//  se recalculent automatiquement à partir des données ci-dessus.
//  Aucune édition n'est requise dans App.js pour une mise à jour de données.
// ═══════════════════════════════════════════════════════════════════════════

// Date de la dernière mise à jour de ce fichier (affichée dans l'app)
export const LAST_UPDATE = "06-juin-2026";

export const REAL_PRICES = {
  16: {
    "Peru":         { 14:[13.00,13.50],16:[12.75,13.25],18:[12.25,12.75],20:[11.75,12.25],22:[10.75,11.25],24:[9.25,9.75],26:[1.90,2.00],28:[1.80,1.90],30:[1.50,1.70],32:[1.40,1.60] },
    "Colombia":     { 14:[11.25,11.75],16:[11.00,11.50],18:[11.00,11.50],20:[9.75,10.25],22:[9.25,9.75],24:[8.25,8.75],26:[1.40,1.70],28:[1.30,1.50],30:[1.20,1.40],32:[1.10,1.20] },
    "Spain":        { 14:[14.25,14.75],16:[14.25,14.75],18:[14.00,14.50],20:[13.25,13.75],22:[12.75,13.25],24:[12.75,13.25],26:[2.50,3.00] },
    "South Africa": { 14:[11.75,12.25],16:[11.50,12.00],18:[11.50,12.00],20:[11.25,11.75],22:[10.25,10.75],24:[8.50,9.00] },
    "Brazil":       { 14:[11.75,12.25],16:[11.50,12.00],18:[11.50,12.00],20:[11.25,11.75],22:[10.25,10.75] },
  },
  17: {
    "Peru":         { 14:[13.00,13.50],16:[12.75,13.25],18:[12.50,13.00],20:[11.25,11.75],22:[9.50,10.00],24:[8.00,8.50],26:[1.60,1.80],28:[1.60,1.70],30:[1.30,1.50],32:[1.20,1.30] },
    "Colombia":     { 14:[11.50,12.00],16:[11.50,12.00],18:[11.25,11.75],20:[10.75,11.25],22:[9.00,9.50],24:[7.75,8.25],26:[1.40,1.70],28:[1.30,1.50],30:[1.20,1.50],32:[1.10,1.30] },
    "Spain":        { 14:[14.25,14.75],16:[14.25,14.75],18:[14.00,14.50],20:[12.90,13.40],22:[12.00,12.50],24:[12.00,12.50],26:[2.30,2.80] },
    "South Africa": { 14:[11.75,12.25],16:[11.75,12.25],18:[11.75,12.25],20:[10.75,11.25],22:[9.50,10.00] },
    "Brazil":       { 14:[11.75,12.25],16:[11.50,12.00],18:[11.50,12.00],20:[11.00,11.50],22:[9.75,10.25] },
  },
  18: {
    "Peru":         { 14:[12.50,13.00],16:[12.25,12.75],18:[11.75,12.25],20:[10.75,11.25],22:[10.00,10.50],24:[7.25,7.75],26:[1.50,1.70],28:[1.40,1.60],30:[1.20,1.30],32:[1.20,1.30] },
    "Colombia":     { 14:[11.00,11.50],16:[11.00,11.50],18:[11.00,11.50],20:[10.25,10.75],22:[8.25,8.75],24:[6.25,6.75],26:[1.20,1.60],28:[1.20,1.40],30:[1.15,1.30],32:[1.00,1.20] },
    "South Africa": { 14:[11.50,12.00],16:[11.50,12.00],18:[11.50,12.00],20:[10.25,10.75] },
    "Brazil":       { 14:[11.50,12.00],16:[11.75,12.25],18:[11.50,12.00],20:[10.25,10.75],22:[8.25,8.75] },
  },
  19: {
    "Peru":         { 14:[11.25,11.75],16:[11.25,11.75],18:[11.25,11.75],20:[9.75,10.25],22:[8.25,8.75],24:[7.25,7.75],26:[1.30,1.50],28:[1.20,1.40],30:[1.10,1.30],32:[1.00,1.20] },
    "Colombia":     { 16:[10.25,10.75],18:[10.25,10.75],20:[9.25,9.75],22:[7.75,8.25],24:[6.25,6.75],26:[1.20,1.40],28:[1.10,1.30],30:[1.00,1.20],32:[0.90,1.10] },
    "South Africa": { 14:[8.25,8.75],16:[10.75,11.25],18:[10.75,11.25],20:[9.25,9.75],22:[7.75,8.25] },
    "Brazil":       { 14:[10.00,10.50],16:[10.00,10.50],18:[10.00,10.50],20:[8.75,9.25],22:[7.75,8.25] },
  },
  // S20 — Données OFFICIELLES ProHass S20/2026 (rapport publié 15-mai-2026)
  // Source : Informe comercial semana 20 del 2026 + grille "Semana de venta 20"
  20: {
    "Peru":         { 14:[10.75,11.25],16:[10.75,11.25],18:[10.75,11.25],20:[9.75,10.25],22:[8.00,8.50],24:[7.00,7.50],26:[1.30,1.50],28:[1.20,1.40],30:[1.10,1.30],32:[1.00,1.20] },
    "Colombia":     { 14:[10.00,10.50],16:[10.00,10.50],18:[10.00,10.50],20:[9.25,9.75],22:[7.25,7.75],24:[6.00,6.50],26:[1.30,1.50],28:[1.20,1.30],30:[1.00,1.20],32:[0.90,1.10] },
    "South Africa": { 14:[9.75,10.25],16:[10.00,10.50],18:[10.00,10.50],20:[9.25,9.75],22:[7.25,7.75] },
    "Brazil":       { 14:[8.75,9.25],16:[8.75,9.25],18:[8.75,9.25],20:[8.50,9.00],22:[7.25,7.75] },
  },
  // S22 — Données OFFICIELLES marché S22/2026 (rapport publié 22-mai-2026)
  // Pic d'arrivée confirmé : 883 containers EU (vs 874 S21) — équivaut à 27.97 M kg total EU
  22: {
    "Peru":         { 14:[9.75,10.25],16:[9.75,10.25],18:[9.50,10.00],20:[8.75,9.25],22:[7.25,7.75],24:[6.25,6.75],26:[1.20,1.40],28:[1.10,1.30],30:[1.00,1.20],32:[0.90,1.10] },
    "Colombia":     { 14:[9.25,9.75],16:[9.25,9.75],18:[9.00,9.50],20:[8.25,8.75],22:[6.75,7.25],24:[5.50,6.00],26:[1.20,1.40],28:[1.10,1.20],30:[0.90,1.10],32:[0.80,1.00] },
    "South Africa": { 14:[9.25,9.75],16:[9.50,10.00],18:[9.25,9.75],20:[8.25,8.75],22:[6.75,7.25] },
    "Brazil":       { 14:[8.25,8.75],16:[8.25,8.75],18:[8.25,8.75],20:[8.00,8.50],22:[6.75,7.25] },
  },
  // S23 — Données OFFICIELLES marché S23/2026 (rapport ProHass publié 06-juin-2026)
  // Source : grille "Hass — Semana de venta 23" page 13. Post-pic : 12-18 sous pression, 22-32 récupèrent
  // Phénomène inédit : calibres 16 au prix d'un 18, voire 14 < 16 dans certains programmes
  23: {
    "Peru":         { 14:[7.00,8.00],16:[8.00,9.00],18:[8.00,9.00],20:[8.00,9.00],22:[7.50,8.50],24:[6.50,7.50],26:[1.50,1.60],28:[1.40,1.50],30:[1.30,1.40],32:[1.20,1.30] },
    "Colombia":     { 14:[7.00,7.50],16:[7.00,7.50],18:[7.00,7.50],20:[7.00,7.50],22:[6.00,6.50],24:[5.50,6.50],26:[1.30,1.50],28:[1.20,1.40],30:[1.10,1.20],32:[1.00,1.20] },
    "South Africa": { 14:[6.50,7.00],16:[6.50,8.00],18:[7.00,8.00],20:[7.00,8.00],22:[6.50,7.50],24:[5.50,6.50] },
    "Brazil":       { 14:[5.00,6.00],16:[5.50,6.00],18:[6.00,7.00],20:[6.00,7.00],22:[6.00,6.50],24:[5.50,6.50] },
  },
  // S21 — Estimation interne (la semaine commence lundi 18 mai 2026)
  // Logique : poursuite tendance baissière confirmée par ProHass S20 (Olmos + Chavimochic démarrent,
  // peak containers approche, calibres 26-32 stabilisent grâce à moindre arrivée small fruit)
  21: {
    "Peru":         { 14:[10.25,10.75],16:[10.25,10.75],18:[10.25,10.75],20:[9.25,9.75],22:[7.50,8.00],24:[6.50,7.00],26:[1.25,1.45],28:[1.15,1.35],30:[1.05,1.25],32:[0.95,1.15] },
    "Colombia":     { 14:[9.50,10.00],16:[9.50,10.00],18:[9.50,10.00],20:[8.75,9.25],22:[6.75,7.25],24:[5.50,6.00],26:[1.25,1.45],28:[1.15,1.30],30:[1.00,1.20],32:[0.90,1.10] },
    "South Africa": { 14:[9.25,9.75],16:[9.50,10.00],18:[9.50,10.00],20:[8.75,9.25],22:[6.75,7.25] },
    "Brazil":       { 14:[8.25,8.75],16:[8.25,8.75],18:[8.25,8.75],20:[8.00,8.50],22:[6.75,7.25] },
  },
};
export const LATEST_WEEK = 23;
// Indice CIRAD calibre 18 — Source : graphique ProHass S23 (publié 06-juin-2026)
// Note S23 : S20-S22 révisés à la baisse vs précédent rapport. S22=8.89 montre LÉGER REBOND vs S21=8.81
export const CIRAD_REF = { 11:11.97,12:11.86,13:12.14,14:12.22,15:12.30,16:12.45,17:11.87,18:11.21,19:10.58,20:9.57,21:8.81,22:8.89 };
// Disponibilité TOTALE EU (M kg/semaine, tous origines) — Source : tableau arrivées ProHass S23
// S22 = 27.97 M kg (PIC confirmé), S23 = 24.0 M kg projeté. Cumul S1-S22 = 485 M kg (+20% vs 2025=405)
export const WEEKLY_SUPPLY_EU = { 14:22.3,15:20.5,16:20.9,17:24.6,18:25.6,19:23.6,20:24.2,21:26.3,22:28.0,23:24.0 };
export const REAL_WEEKS = [14,15,16,17,18,19,20,21,22,23];
// TOP 10 importateurs Pérou → Europe — Manifest officiel publié 28-mai-2026
// Cumul S1-S22 confirmé. Volumes hebdo S20-S23 (S23 = snapshot partiel au 28-mai)
// Structure : weeks est un dict {numéro_semaine: containers}. Ajoutez/retirez des entrées
// pour mettre à jour automatiquement le toggle et les colonnes de l'app.
export const TOP_IMPORTERS = [
  { name:"Nature's Pride BV",                country:"NL", cumul:438, weeks:{20:84, 21:80, 22:62, 23:72} },
  { name:"Trops Import-Export SL",           country:"ES", cumul:282, weeks:{20:44, 21:59, 22:44, 23:48} },
  { name:"OGL Food Trade GmbH",              country:"DE", cumul:234, weeks:{20:38, 21:40, 22:50, 23:34} },
  { name:"Hillfresh International BV",       country:"NL", cumul:200, weeks:{20:21, 21:13, 22:6,  23:2 } },
  { name:"Frutas Montosa SL",                country:"ES", cumul:195, weeks:{20:15, 21:20, 22:22, 23:23} },
  { name:"Axarfruit SL",                     country:"ES", cumul:165, weeks:{20:13, 21:7,  22:6,  23:3 } },
  { name:"CMR Group",                        country:"FR", cumul:150, weeks:{20:18, 21:18, 22:15, 23:10} },
  { name:"HL Hall International Ltd",        country:"UK", cumul:145, weeks:{20:8,  21:14, 22:17, 23:18} },
  { name:"Cía Aguacatera del Sur SL",        country:"ES", cumul:142, weeks:{20:17, 21:15, 22:13, 23:14} },
  { name:"Roveg Fruit BV",                   country:"NL", cumul:132, weeks:{20:11, 21:6,  22:9,  23:11} },
];
export const CALIBRES_LIST = [14,16,18,20,22,24,26,28,30,32];
export const ORIGIN_COLOR = { "Peru":"#f59e0b","Colombia":"#4ade80","South Africa":"#34d399","Brazil":"#60a5fa","Spain":"#f87171" };
export const ORIGIN_FLAG  = { "Peru":"🇵🇪","Colombia":"🇨🇴","South Africa":"🇿🇦","Brazil":"🇧🇷","Spain":"🇪🇸" };

// ─── PRÉVISIONS S24-S27 ──────────────────────────────────────────────────────
// S23 maintenant en données réelles. Pic confirmé S22 (27.97 M kg EU, 883 cnt Pérou),
// S23 = 24 M kg. Pérou décélère (+4% YTD vs +15% projeté), risque fin saison anticipée fin juillet.
// USA en tension (fuerza mayor Mexique) → arbitrage potentiel allègerait pression EU.
export const FORECAST_WEEKS = [24, 25, 26, 27];

// Prévisions de prix par origine et calibre [min, max]
// Logique : pic dépassé S22, calibres 12-18 stocks lourds (rebond lent), calibres 22-32 récupération entamée
// Si Pérou termine 3-4 sem plus tôt → accélération hausse dès S26-S27
export const FORECAST_PRICES = {
  24: {
    "Peru":         { 14:[7.00,8.00],16:[8.00,9.00],18:[8.00,9.00],20:[8.00,9.00],22:[7.50,8.50],24:[6.50,7.50],26:[1.55,1.70],28:[1.45,1.60],30:[1.35,1.50],32:[1.25,1.40] },
    "Colombia":     { 14:[7.00,7.50],16:[7.00,7.50],18:[7.00,7.50],20:[7.00,7.50],22:[6.00,6.50],24:[5.50,6.50],26:[1.35,1.55],28:[1.25,1.45],30:[1.15,1.30],32:[1.05,1.25] },
    "South Africa": { 14:[6.75,7.25],16:[6.75,8.00],18:[7.00,8.00],20:[7.00,8.00],22:[6.50,7.50] },
    "Brazil":       { 16:[5.50,6.50],18:[6.00,7.00],20:[6.00,7.00],22:[6.00,6.50] },
  },
  25: {
    "Peru":         { 14:[7.25,8.25],16:[8.00,9.00],18:[8.00,9.00],20:[8.00,9.00],22:[7.75,8.75],24:[6.75,7.75],26:[1.65,1.80],28:[1.55,1.70],30:[1.45,1.60],32:[1.35,1.50] },
    "Colombia":     { 14:[7.00,7.75],16:[7.00,7.75],18:[7.00,7.75],20:[7.00,7.75],22:[6.25,6.75],24:[5.75,6.75],26:[1.45,1.65],28:[1.35,1.55],30:[1.25,1.40],32:[1.15,1.35] },
    "South Africa": { 14:[6.75,7.50],16:[7.00,8.00],18:[7.25,8.25],20:[7.25,8.25],22:[6.75,7.75] },
  },
  26: {
    "Peru":         { 14:[7.50,8.50],16:[8.25,9.25],18:[8.25,9.25],20:[8.25,9.25],22:[8.00,9.00],24:[7.00,8.00],26:[1.75,1.95],28:[1.65,1.85],30:[1.55,1.75],32:[1.45,1.65] },
    "Colombia":     { 14:[7.25,8.00],16:[7.25,8.00],18:[7.25,8.00],20:[7.25,8.00],22:[6.50,7.00],24:[6.00,7.00],26:[1.55,1.80],28:[1.45,1.70],30:[1.35,1.55],32:[1.25,1.50] },
    "South Africa": { 14:[7.00,8.00],16:[7.25,8.25],18:[7.50,8.50],20:[7.50,8.50],22:[7.00,8.00] },
  },
  27: {
    "Peru":         { 14:[8.00,9.00],16:[8.75,9.75],18:[8.75,9.75],20:[8.75,9.75],22:[8.25,9.25],24:[7.25,8.50],26:[1.90,2.10],28:[1.80,2.00],30:[1.70,1.90],32:[1.60,1.80] },
    "Colombia":     { 14:[7.50,8.50],16:[7.50,8.50],18:[7.50,8.50],20:[7.50,8.50],22:[7.00,7.75],24:[6.50,7.50],26:[1.70,1.95],28:[1.60,1.85],30:[1.50,1.70],32:[1.40,1.65] },
    "South Africa": { 14:[7.25,8.25],16:[7.50,8.50],18:[7.75,8.75],20:[7.75,8.75],22:[7.25,8.25] },
  },
};

// Volumes ARRIVÉE TOTALE EU prévus (M kg/semaine, tous origines)
// Base : projection ProHass S23 = 24 M kg, puis décrue progressive (Pérou + Colombie + SA en baisse)
// Si Pérou termine fin juillet : décélération accélérée à partir de S29-S30
export const FORECAST_SUPPLY = { 24:22.5, 25:20.5, 26:18.5, 27:17.0 };

// Tendance globale par semaine et catégorie de calibres
// Légende : ↘↘ très baissier · ↘ baissier · = stable · ↗ haussier · ↗↗ très haussier
export const FORECAST_TREND = {
  24: { big:"=", medium:"=", small:"↗", note:"Arrivées EU ~22.5 M kg. Calibres 12-18 sous pression (stocks lourds), 22-32 récupération entamée." },
  25: { big:"↗", medium:"=", small:"↗", note:"Arrivées EU ~20.5 M kg. Détente progressive. USA cherche Pérou/Colombie → arbitrage allège EU." },
  26: { big:"↗", medium:"↗", small:"↗", note:"Arrivées EU ~18.5 M kg. Rebond confirmé. Si Pérou termine fin juillet, accélération hausse." },
  27: { big:"↗↗", medium:"↗", small:"↗", note:"Arrivées EU ~17 M kg. Hausse marquée gros calibres. Scénario fin saison anticipée se précise." },
};

// Carte stratégique acheteur — recommandation par semaine
export const FORECAST_STRATEGY = {
  24: { color:"#f59e0b", label:"🟡 OPPORTUNISTE", reason:"Post-pic. Sécuriser dernières opportunités prix bas calibres 12-18. Petits calibres déjà en hausse." },
  25: { color:"#1e40af", label:"🔵 ANTICIPER", reason:"Détente confirmée. Acheter avant rebond généralisé. Surveiller flux Pérou détournés vers USA." },
  26: { color:"#1e40af", label:"🔵 STOCK STRATÉGIQUE", reason:"Hausse en cours sur tous calibres. Constituer stocks 22-32, négocier programmes 18-20 long terme." },
  27: { color:"#dc2626", label:"🔴 URGENCE", reason:"Si scénario fin saison anticipée Pérou : pénurie possible. Verrouiller programmes août dès maintenant." },
};

// Facteurs marché & contexte (impactent les prévisions) — Mise à jour S23
export const FORECAST_FACTORS = [
  { icon:"⚠️", label:"Pic dépassé S22 — 27.97 M kg EU", impact:"Cumul S1-S22 = 485 M kg (+20% vs 2025). Pression maximale, début décrue.", weight:"high" },
  { icon:"📉", label:"Pérou : décélération exports", impact:"Cumul YTD +4% vs 2025 seulement (vs +15% projeté initialement). Cosechas ralenties.", weight:"high" },
  { icon:"⏱️", label:"Pérou : fin saison anticipée possible", impact:"Scénario fin juillet (vs fin août) gagne du terrain. Confirmer S26-S27.", weight:"high" },
  { icon:"🚨", label:"USA : fuerza mayor Mexique", impact:"Mission/Westfalia déclarent. USA cherche Pérou/Colombie → soulagement EU potentiel.", weight:"high" },
  { icon:"⚖️", label:"Déséquilibre calibres 12-18 vs 22-32", impact:"Inédit : cal 16 au prix d'un 18, voire 14<16. Petits calibres en récupération.", weight:"high" },
  { icon:"🇨🇴", label:"Colombie : effondrement -60% vs 2025", impact:"Flor traviesa faible — 50-60 cnt/sem (vs 130 LY), 55% USA / 45% EU.", weight:"medium" },
  { icon:"🏭", label:"Industrie absorbe le surplus", impact:"Guacamole, congelé, huile en Europe — décharge marché frais des calibres gros.", weight:"medium" },
  { icon:"🇲🇽", label:"Mexique : flor loca anticipée 3 sem", impact:"Jalisco + Michoacán démarrent — stabilisation USA été 2026.", weight:"medium" },
  { icon:"🌡️", label:"El Niño : signaux Pérou/Colombie", impact:"Chaleur prolongée → flor principal Colombie +30%, récolte anticipée 3-4 sem.", weight:"medium" },
  { icon:"🇿🇦🇪🇸", label:"Sortie Maluma SA + fin Espagne", impact:"Concurrence locale disparue, Pérou domine. SA -50% volumes.", weight:"low" },
];

// ═══════════════════════════════════════════════════════════════════════════
// DONNÉES SAISON 2026 — Estimations agrégées multi-sources (analyse interne)
// ═══════════════════════════════════════════════════════════════════════════

// Volumes hebdomadaires Pérou TOTAL toutes destinations 2026 (TM)
// Réel S01-S14, Projeté S15-S52
export const PERU_WEEKLY_TOTAL = {
  6:3105,7:2330,8:6119,9:7190,10:8846,11:10790,12:16830,13:16350,14:17240,
  15:22110,16:26800,17:26030,18:28390,19:30840,20:32220,21:32920,22:34100,23:35190,
  24:33250,25:31800,26:31520,27:30940,28:30760,29:30580,30:29510,31:25410,
  32:24140,33:25230,34:22880,35:21620,36:16420,37:13370,38:7182,39:2953,
};

// Volumes hebdomadaires Pérou → EUROPE 2026 (TM)
export const PERU_WEEKLY_EUROPE = {
  6:1871,7:2167,8:4238,9:5324,10:7496,11:9177,12:9970,13:12540,14:13140,
  15:15620,16:19480,17:19490,18:19890,19:19610,20:20010,21:20320,22:20030,23:19640,
  24:19550,25:17670,26:17480,27:18080,28:18090,29:18100,30:17910,31:15720,
  32:15130,33:16730,34:16340,35:15450,36:12570,37:10780,38:5789,39:2496,
};

// Volumes hebdomadaires Pérou → USA 2026 (TM)
export const PERU_WEEKLY_USA = {
  15:999,16:1799,17:2000,18:2701,19:3702,20:3804,21:5608,22:5811,23:6716,
  24:7621,25:7323,26:7627,27:6727,28:6931,29:6532,30:6333,31:5330,
  32:4930,33:4630,34:3524,35:3022,36:2016,37:1311,38:504,
};

// Volumes hebdomadaires Pérou → ASIE 2026 (TM)
export const PERU_WEEKLY_ASIA = {
  3:767,4:131,5:1091,6:1212,8:1658,9:1567,10:607,11:435,12:132,13:1924,
  14:1925,15:3315,16:3225,17:1968,18:3420,19:3940,20:4124,21:3394,22:4422,23:4394,
  24:2890,25:3257,26:2872,27:1864,28:1437,29:1081,30:938,31:1990,
  32:1899,33:1920,34:1563,35:1400,
};

// ─── TRANSIT MARITIME ─────────────────────────────────────────────────────
// Délai moyen Callao → ports Europe (Rotterdam, Algeciras, Hamburg)
// Moyenne 3 semaines (21 jours) selon les compagnies maritimes
export const TRANSIT_WEEKS = 3;

// Calcul automatique des ARRIVÉES Europe = départs S-3
// Ex: arrivée S22 = départ S19
export function computeEUArrivals(departures) {
  const arrivals = {};
  Object.entries(departures).forEach(([w, tm]) => {
    const arrivalWeek = Number(w) + TRANSIT_WEEKS;
    arrivals[arrivalWeek] = tm;
  });
  return arrivals;
}

// Volumes ARRIVÉE en Europe (calculés depuis départs Pérou + 3 semaines)
// C'est CE QUI PRESSE RÉELLEMENT LES PRIX EU
export const PERU_ARRIVALS_EUROPE = computeEUArrivals({
  6:1879,7:2167,8:4297,9:5395,10:7593,11:9358,12:10100,13:12760,14:13317,
  15:15890,16:19720,17:19620,18:20140,19:19770,20:20240,21:20470,22:20240,23:19790,
  24:19660,25:17720,26:17640,27:18270,28:18130,29:18250,30:18030,31:15780,
  32:15220,33:16770,34:16470,35:15510,36:12640,37:10840,38:5810,39:2510,
});

// Export annuel Pérou TOTAL (TM)
export const PERU_ANNUAL_TOTAL = {
  2020:384200, 2021:505900, 2022:583900, 2023:592200, 2024:535700, 2025:740500, 2026:781600,
};

// Export annuel Pérou → Europe (TM)
export const PERU_ANNUAL_EUROPE = {
  2020:241100, 2021:293000, 2022:330300, 2023:360300, 2024:335500, 2025:465100, 2026:501400,
};

// Export annuel Pérou → USA (TM)
export const PERU_ANNUAL_USA = {
  2020:80270, 2021:87270, 2022:127400, 2023:76760, 2024:63800, 2025:98200, 2026:103700,
};

// Export annuel Pérou → Asie (TM)
export const PERU_ANNUAL_ASIA = {
  2020:29310, 2021:45200, 2022:47720, 2023:71030, 2024:52000, 2025:73360, 2026:79590,
};

// Répartition Pérou → Europe par pays 2026 — pct calculé auto depuis tm (modifie seulement tm)
const _peruEuRaw = [
  { country:"Pays-Bas",   flag:"🇳🇱", tm:207400, evol:15 },
  { country:"Espagne",    flag:"🇪🇸", tm:137000, evol:-3 },
  { country:"Royaume-Uni",flag:"🇬🇧", tm:56860,  evol:15 },
  { country:"France",     flag:"🇫🇷", tm:22760,  evol:-9 },
  { country:"Allemagne",  flag:"🇩🇪", tm:16460,  evol:8 },
  { country:"Belgique",   flag:"🇧🇪", tm:2492,   evol:-2 },
  { country:"Autres",     flag:"🇪🇺", tm:34120,  evol:14 },
];
const _peruEuTotal = _peruEuRaw.reduce((s,c)=>s+c.tm,0);
export const PERU_EUROPE_BY_COUNTRY = _peruEuRaw.map(c=>({...c,pct:Math.round(c.tm/_peruEuTotal*100*10)/10}));

// Répartition Pérou → Asie par pays 2026 — pct calculé auto depuis tm
const _peruAsiaRaw = [
  { country:"Chine",     flag:"🇨🇳", tm:44430, evol:2 },
  { country:"Japon",     flag:"🇯🇵", tm:23220, evol:15 },
  { country:"Corée Sud", flag:"🇰🇷", tm:10980, evol:22 },
  { country:"Thaïlande", flag:"🇹🇭", tm:392,   evol:5 },
  { country:"Autres",    flag:"🌏", tm:1143,  evol:64 },
];
const _peruAsiaTotal = _peruAsiaRaw.reduce((s,c)=>s+c.tm,0);
export const PERU_ASIA_BY_COUNTRY = _peruAsiaRaw.map(c=>({...c,pct:Math.round(c.tm/_peruAsiaTotal*100*10)/10}));

// Répartition Pérou → USA par côte 2026 — pct calculé auto depuis tm
const _peruUsaRaw = [
  { port:"Côte Est",   tm:80950, evol:14 },
  { port:"Côte Ouest", tm:16810, evol:-12 },
  { port:"Savannah",   tm:2985,  evol:-34 },
  { port:"Miami",      tm:3663,  evol:-9 },
  { port:"Houston",    tm:603,   evol:-39 },
];
const _peruUsaTotal = _peruUsaRaw.reduce((s,p)=>s+p.tm,0);
export const PERU_USA_BY_PORT = _peruUsaRaw.map(p=>({...p,pct:Math.round(p.tm/_peruUsaTotal*100*10)/10}));

// Répartition mondiale par destination Pérou 2026 (donut)
export const PERU_DESTINATIONS_2026 = [
  { name:"Europe", pct:64, color:"#16a34a" },
  { name:"USA",    pct:14, color:"#f59e0b" },
  { name:"Chili",  pct:8,  color:"#fbbf24" },
  { name:"Chine",  pct:6,  color:"#dc2626" },
  { name:"Japon",  pct:3,  color:"#3b82f6" },
  { name:"Autres", pct:5,  color:"#a855f7" },
];

// Hectares cultivées Pérou par année
export const PERU_HECTARES_HISTORY = {
  2018:52900, 2019:62350, 2020:68970, 2021:75380, 2022:79660,
  2023:81290, 2024:81560, 2025:81620,
};

// Hectares mondiales 2025 par pays (top 10)
export const WORLD_HECTARES_2025 = [
  { country:"Mexique",    flag:"🇲🇽", ha:258000 },
  { country:"Pérou",      flag:"🇵🇪", ha:84000 },
  { country:"Colombie",   flag:"🇨🇴", ha:40000 },
  { country:"Chili",      flag:"🇨🇱", ha:32000 },
  { country:"Californie", flag:"🇺🇸", ha:21000 },
  { country:"Kenya",      flag:"🇰🇪", ha:15000 },
  { country:"Espagne",    flag:"🇪🇸", ha:15000 },
  { country:"Sudáfrica",  flag:"🇿🇦", ha:14000 },
  { country:"Australie",  flag:"🇦🇺", ha:12000 },
  { country:"Maroc",      flag:"🇲🇦", ha:10000 },
];

// Régions productrices Pérou avec calendrier de récolte
export const PERU_REGIONS = [
  { name:"La Libertad", ha:18810, producers:1720, harvestMonths:[5,6,7,8],          peak:"Mai-Août",    note:"Région majeure Costa Norte" },
  { name:"Lima",        ha:14892, producers:5401, harvestMonths:[4,5,6,7,8,9],      peak:"Avr-Sep",     note:"Costa Centro, exporters historiques" },
  { name:"Ica",         ha:13858, producers:3250, harvestMonths:[5,6,7,8,9],        peak:"Mai-Sep",     note:"Costa Sur, qualité premium" },
  { name:"Lambayeque",  ha:12844, producers:396,  harvestMonths:[3,4,5,6,7,8,9],    peak:"Mar-Sep",     note:"Olmos — moteur volumes 2026" },
  { name:"Ancash",      ha:6278,  producers:3489, harvestMonths:[4,5,6,7,8,9],      peak:"Avr-Sep",     note:"Costa Norte" },
  { name:"Huancavelica",ha:4475,  producers:3940, harvestMonths:[2,3,4],            peak:"Fév-Avr",     note:"Sierra — démarrage saison" },
  { name:"Ayacucho",    ha:4063,  producers:6030, harvestMonths:[2,3,4],            peak:"Fév-Avr",     note:"Sierra — petits producteurs" },
  { name:"Arequipa",    ha:2167,  producers:1417, harvestMonths:[3,4,5,8,9],        peak:"Mar-Sep",     note:"Bi-saison" },
  { name:"Apurímac",    ha:1601,  producers:1687, harvestMonths:[2,3,4],            peak:"Fév-Avr",     note:"Sierra Sur" },
  { name:"Cusco",       ha:1260,  producers:1177, harvestMonths:[3,4,5,6],          peak:"Mar-Juin",    note:"Sierra Sud-Est" },
];

// Insights stratégiques saison 2026 (résumé exécutif) — MAJ S23
export const PERU_2026_INSIGHTS = [
  { icon:"📊", title:"Cumul EU S1-S22",  value:"485 M kg",    detail:"+20% vs 2025 (405 M kg) — record historique d'arrivées" },
  { icon:"📉", title:"Décélération exports", value:"+4% YTD",  detail:"vs +15% projeté initialement — ralentissement net" },
  { icon:"⚠️", title:"Pic confirmé",     value:"S22 = 28 M kg",  detail:"Total EU tous origines, 883 cnt Pérou — début décrue" },
  { icon:"⏱️", title:"Fin saison",       value:"fin juillet ?", detail:"Scénario anticipé (-3 à -4 sem vs fin août initial)" },
  { icon:"⚖️", title:"Calibres",          value:"12-18 vs 22-32", detail:"Déséquilibre inédit : gros surstockés, petits récupèrent" },
  { icon:"🇺🇸", title:"USA fuerza mayor", value:"Mission/Westfalia", detail:"Arbitrage potentiel Pérou/Colombie → allège EU" },
];


// ─── DONNÉES TRACKING CONTENEURS S21 ──────────────────────────────────────
// Source : Manifest portuaire saison 2026 + ProHass S20 (containers Pérou EU S19 = 820 réels)

// Top ports d'arrivée Europe (containers cumulés 2026)
export const TOP_EU_PORTS = [
  { port:"Rotterdam",     country:"NL", flag:"🇳🇱", containers:4180, pct:48 },
  { port:"Algeciras",     country:"ES", flag:"🇪🇸", containers:1812, pct:21 },
  { port:"Vlissingen",    country:"NL", flag:"🇳🇱", containers:813,  pct:9 },
  { port:"St. Petersburg",country:"RU", flag:"🇷🇺", containers:455,  pct:5 },
  { port:"London Gateway",country:"UK", flag:"🇬🇧", containers:395,  pct:4 },
  { port:"Málaga",        country:"ES", flag:"🇪🇸", containers:380,  pct:4 },
  { port:"Southampton",   country:"UK", flag:"🇬🇧", containers:207,  pct:2 },
  { port:"Dover",         country:"UK", flag:"🇬🇧", containers:152,  pct:2 },
  { port:"Livorno",       country:"IT", flag:"🇮🇹", containers:132,  pct:1 },
];

// Top exportateurs Pérou — saison 2026
export const TOP_PERU_EXPORTERS = [
  { name:"Westfalia Fruit Perú",      containers:404, share:9.0 },
  { name:"Marand Company SAC",        containers:346, share:7.7 },
  { name:"Fruglobe Group",            containers:309, share:6.9 },
  { name:"Corporación Agrolatina",    containers:292, share:6.5 },
  { name:"Eurofresh Peru SAC",        containers:284, share:6.3 },
  { name:"Añay Peruvian Fruits",      containers:278, share:6.2 },
  { name:"Agrícola Pampa Baja",       containers:276, share:6.1 },
  { name:"Agrocosta Peru SAC",        containers:247, share:5.5 },
  { name:"TAL SA",                    containers:242, share:5.4 },
  { name:"Exportadora El Parque",     containers:234, share:5.2 },
];

// Top compagnies maritimes (volumes Europe)
export const TOP_SHIPPING_COMPANIES = [
  { name:"Maersk",      containers:2252, pct:27, transit:"21j (Rotterdam)" },
  { name:"CMA-CGM",     containers:1725, pct:21, transit:"22j (Algeciras)" },
  { name:"Hapag-Lloyd", containers:1335, pct:16, transit:"21j (Rotterdam)" },
  { name:"MSC",         containers:1264, pct:15, transit:"23j (multi)" },
  { name:"COSCO",       containers:143,  pct:2,  transit:"22j (Algeciras)" },
  { name:"OOCL",        containers:127,  pct:2,  transit:"21j (Rotterdam)" },
];

// Containers ARRIVÉES Europe par semaine — Source : Manifest officiel publié 28-mai-2026
// Données réelles ETA jusqu'à S22 (PIC = 786 cnt confirmé). 
// S23+ = bookings partiels snapshot 28-mai — alertes : S24 montre déjà 821 cnt bookés (potentiel nouveau pic).
export const PERU_EU_CONTAINERS_BY_WEEK = {
  14:381, 15:376, 16:534, 17:575, 18:598, 19:590, 20:742, 21:771, 22:786, 23:655, 24:821, 25:27, 26:4,
};

// ═══════════════════════════════════════════════════════════════════════════
// HELPERS DÉRIVÉS — utilisés par App.js pour générer labels & KPI dynamiquement
// Aucune valeur ne doit être hardcodée ici : tout vient des constantes ci-dessus.
// À chaque update hebdo, modifier UNIQUEMENT les données ci-dessus, jamais ces helpers.
// ═══════════════════════════════════════════════════════════════════════════

// Bornes semaines réelles & prévisions
export const FIRST_REAL_WEEK = Math.min(...REAL_WEEKS);
export const LAST_REAL_WEEK  = Math.max(...REAL_WEEKS);
export const FIRST_FORECAST_WEEK = Math.min(...FORECAST_WEEKS);
export const LAST_FORECAST_WEEK  = Math.max(...FORECAST_WEEKS);

// Dernières semaines CIRAD disponibles (le rapport publie CIRAD avec 1 sem de décalage)
const _ciradWeeks = Object.keys(CIRAD_REF).map(Number).sort((a,b)=>a-b);
export const CIRAD_LAST_WEEK = _ciradWeeks[_ciradWeeks.length-1];
export const CIRAD_PREV_WEEK = _ciradWeeks[_ciradWeeks.length-2];

// Détection automatique du pic d'arrivée Pérou EU (parmi les semaines réelles seulement)
const _peakEntry = Object.entries(PERU_EU_CONTAINERS_BY_WEEK)
  .filter(([w]) => REAL_WEEKS.includes(Number(w)))
  .reduce((peak, e) => (e[1] > peak[1] ? e : peak), ["0", -Infinity]);
export const PEAK_WEEK = Number(_peakEntry[0]);
export const PEAK_CONTAINERS = _peakEntry[1];

// Date de publication du dernier manifest Excel ingéré (à mettre à jour avec chaque Excel)
export const MANIFEST_DATE = "28-mai-2026";

// Changement CIRAD entre les 2 dernières semaines connues (pour KPI dynamique)
export const CIRAD_LAST_VAL  = CIRAD_REF[CIRAD_LAST_WEEK];
export const CIRAD_PREV_VAL  = CIRAD_REF[CIRAD_PREV_WEEK];
export const CIRAD_CHANGE_PCT = ((CIRAD_LAST_VAL - CIRAD_PREV_VAL) / CIRAD_PREV_VAL * 100);
export const CIRAD_TREND_ICON = CIRAD_CHANGE_PCT > 0.1 ? "↗" : CIRAD_CHANGE_PCT < -0.1 ? "↘" : "=";
